module.exports = __webpack_public_path__ + "img/dark.009dac5b.png";